interface ToDateOptions {
  apiName?: string
}

export function subscriptionServiceDateStringToDate(
  value: string | null,
  options?: ToDateOptions
): Date | undefined {
  if (!value || value === '0001-01-01T00:00:00Z') return undefined
  const date = new Date(value)
  if (!date || isNaN(date.valueOf())) {
    throw new Error(
      `Provided a date in an invalid format: ${value} ${
        options?.apiName ? `API: ${options?.apiName}` : ''
      }`
    )
  }
  return date
}
